(() => {
  if (window.__shopCarouselLightboxInit) return;
  window.__shopCarouselLightboxInit = true;

  const dialog = document.createElement('dialog');
  dialog.className = 'shop-lightbox';
  dialog.setAttribute('aria-label', 'Image preview');
  dialog.innerHTML = `
    <div class="shop-lightbox__panel">
      <button type="button" class="shop-lightbox__close" data-shop-lightbox-close aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">
          <path d="M18 6L6 18M6 6l12 12"/>
        </svg>
      </button>
      <button type="button" class="shop-lightbox__nav shop-lightbox__nav--prev" data-shop-lightbox-prev aria-label="Previous image">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M15 18l-6-6 6-6"/>
        </svg>
      </button>
      <img class="shop-lightbox__image" alt="">
      <button type="button" class="shop-lightbox__nav shop-lightbox__nav--next" data-shop-lightbox-next aria-label="Next image">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M9 18l6-6-6-6"/>
        </svg>
      </button>
    </div>
  `;

  document.body.appendChild(dialog);

  const imageEl = dialog.querySelector('.shop-lightbox__image');
  const prevBtn = dialog.querySelector('[data-shop-lightbox-prev]');
  const nextBtn = dialog.querySelector('[data-shop-lightbox-next]');
  let group = [];
  let index = 0;
  let suppressLightboxClick = false;
  let touchStartX = 0;
  let touchStartY = 0;

  const isHorizontalScrollArea = (target) =>
    Boolean(
      target?.closest('[class*="shop-notices-track-wrap"]') ||
        target?.closest('[class*="shop-videos-scroll"]') ||
        target?.closest('[class*="home-events-track"]')
    );

  document.addEventListener(
    'touchstart',
    (event) => {
      if (!isHorizontalScrollArea(event.target)) return;
      touchStartX = event.touches[0]?.clientX || 0;
      touchStartY = event.touches[0]?.clientY || 0;
      suppressLightboxClick = false;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    (event) => {
      if (!isHorizontalScrollArea(event.target)) return;
      const touch = event.touches[0];
      if (!touch) return;
      const deltaX = Math.abs(touch.clientX - touchStartX);
      const deltaY = Math.abs(touch.clientY - touchStartY);
      if (deltaX > 8 && deltaX > deltaY) {
        suppressLightboxClick = true;
      }
    },
    { passive: true }
  );

  const getTriggers = (groupId) =>
    Array.from(document.querySelectorAll(`[data-shop-lightbox-trigger][data-shop-lightbox-group="${groupId}"]`));

  const updateNav = () => {
    const showNav = group.length > 1;
    prevBtn.hidden = !showNav;
    nextBtn.hidden = !showNav;
    prevBtn.disabled = !showNav;
    nextBtn.disabled = !showNav;
  };

  const show = () => {
    const trigger = group[index];
    if (!trigger || !imageEl) return;

    imageEl.src = trigger.dataset.shopLightboxSrc || trigger.querySelector('img')?.currentSrc || trigger.querySelector('img')?.src || '';
    imageEl.alt = trigger.dataset.shopLightboxAlt || trigger.querySelector('img')?.alt || '';
    updateNav();
  };

  const open = (trigger) => {
    const groupId = trigger.dataset.shopLightboxGroup;
    if (!groupId) return;

    group = getTriggers(groupId);
    index = group.indexOf(trigger);
    if (index < 0) {
      index = parseInt(trigger.dataset.shopLightboxIndex, 10) || 0;
    }

    show();

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    }
  };

  const close = () => {
    if (dialog.open) dialog.close();
    if (imageEl) imageEl.removeAttribute('src');
  };

  const step = (delta) => {
    if (group.length <= 1) return;
    index = (index + delta + group.length) % group.length;
    show();
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-shop-lightbox-trigger]');
    if (trigger) {
      if (suppressLightboxClick) {
        suppressLightboxClick = false;
        return;
      }
      event.preventDefault();
      open(trigger);
      return;
    }

    if (event.target.closest('[data-shop-lightbox-close]')) {
      event.preventDefault();
      close();
      return;
    }

    if (event.target.closest('[data-shop-lightbox-prev]')) {
      event.preventDefault();
      step(-1);
      return;
    }

    if (event.target.closest('[data-shop-lightbox-next]')) {
      event.preventDefault();
      step(1);
    }
  });

  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    close();
  });

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) close();
  });

  document.addEventListener('keydown', (event) => {
    const trigger = event.target.closest('[data-shop-lightbox-trigger]');
    if (trigger && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      open(trigger);
    }
  });

  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      step(-1);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      step(1);
    }
  });
})();
